import { Badge } from 'src/components/atoms/Badge';
import { CardContainerStyled } from 'src/components/atoms/CardContainer/CardContainer.styles';
import { textStyleCss } from 'src/theme/atlas';
import styled, { css } from 'styled-components';

export const StyledCardContainer = styled(CardContainerStyled)`
  width: 100%;
  border: none;
  border-radius: 12px;
  background: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newPalette.neutral.N0
      : props.theme.atlas.semantic.color.surface.default};
  box-shadow:
    0 8px 24px -6px rgba(0, 0, 0, 0.16),
    0 0 1px 0 rgba(0, 0, 0, 0.4);
  display: flex;
  flex-direction: column;
  height: 100%;

  > div {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
  }
`;

export const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex: 1;
  min-height: 0;
`;

export const CategoryName = styled.h3`
  margin: 0;
  ${({ theme }) =>
    theme.isVaultVariant
      ? theme.newTypography.textStyleBodySemibold
      : textStyleCss(theme.atlas.typography.semantic.bodySmall)}
  font-weight: 600;
  color: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newPalette.neutral.N800
      : props.theme.atlas.semantic.color.type.default};
`;

export const CategoryCardStatusBadge = styled(Badge)<{ $isActive: boolean }>`
  display: flex;
  padding: 4px 12px;
  justify-content: center;
  align-items: center;
  gap: 2px;
  border-radius: 14px;
  ${(props) =>
    props.$isActive
      ? css`
          background-color: ${props.theme.isVaultVariant
            ? props.theme.newPalette.neutral.N800
            : props.theme.atlas.semantic.color.type.default};
          color: ${props.theme.isVaultVariant
            ? props.theme.newPalette.neutral.N0
            : props.theme.atlas.semantic.color.type.inverse};
          border: none;
        `
      : css`
          background-color: ${props.theme.isVaultVariant
            ? props.theme.newPalette.turquoise.T100
            : props.theme.atlas.semantic.color.surface.variant};
          color: ${props.theme.isVaultVariant
            ? props.theme.newPalette.neutral.N800
            : props.theme.atlas.semantic.color.type.default};
          border: none;
        `}
`;

export const TextGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const CategoryDescription = styled.p<{ $expanded?: boolean }>`
  margin: 0;
  ${({ theme }) =>
    theme.isVaultVariant
      ? theme.newTypography.textStyleBodySmall
      : textStyleCss(theme.atlas.typography.semantic.caption)}
  color: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newPalette.neutral.N800
      : props.theme.atlas.semantic.color.type.default};
  line-height: 1.5;
  ${(props) =>
    !props.$expanded &&
    css`
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
    `}
`;

export const SeeMoreButton = styled.button`
  ${({ theme }) =>
    theme.isVaultVariant
      ? theme.newTypography.textStyleBodySmall
      : textStyleCss(theme.atlas.typography.semantic.caption)}
  color: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newPalette.turquoise.T300
      : props.theme.atlas.semantic.color.action.primary.default};
  cursor: pointer;
  background: none;
  border: none;
  padding: 0;

  &:hover {
    text-decoration: underline;
  }

  &:focus {
    outline: 2px solid
      ${(props) =>
        props.theme.isVaultVariant
          ? props.theme.newPalette.turquoise.T300
          : props.theme.atlas.semantic.color.action.primary.default};
    outline-offset: 2px;
    border-radius: 2px;
  }
`;
